import React from 'react';
import { ChevronLeft } from 'shared/assets/icons';
import { Checkbox } from 'shared/components/ui/checkbox';
import { Collapse } from 'shared/components/ui/collapse';
import { IconButton } from 'shared/components/ui/icon-button';
import { useToggle } from 'shared/hooks/use-toggle';
import { v4 as uuidv4 } from 'uuid';

import * as Styled from './popup-menu.style';

export type PopupMenuItemGroupProps = {
  label: string;
  onChange?: (checked: boolean) => void;
  checked?: boolean;
  id?: string;
  children: React.ReactNode;
  compact?: boolean;
};

export const PopupMenuItemGroup: React.FC<PopupMenuItemGroupProps> = ({
  label,
  checked,
  onChange,
  id = uuidv4(),
  children,
  compact,
}) => {
  const _onChange = () => onChange?.(!checked);
  const [open, toggleOpen] = useToggle();

  return (
    <>
      <Styled.ListItemGroup htmlFor={id} $compact={!!compact}>
        <Checkbox value="" id={id} checked={checked} onChange={_onChange} />
        <Styled.ListItemGroupContent>{label}</Styled.ListItemGroupContent>
        <IconButton
          icon={ChevronLeft}
          rotation={open ? 90 : 0}
          onClick={toggleOpen}
        />
      </Styled.ListItemGroup>

      <Collapse isOpen={open}>{children}</Collapse>
    </>
  );
};
